module.exports = __webpack_public_path__ + "static/img/price-bg.6eac279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/price-bg.png
// module id = x+rf
// module chunks = 36